module.exports = __webpack_public_path__ + "static/media/ind_windows3.5130d4ce.png";